import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import Codes from '@base/features/socket/codes';
import { ISocketClient } from '@base/features/socket/interfaces';
import Utils from '@base/features/socket/utils';
import { CreateTableSettings, ITableSettingsService } from '@base/features/table/interfaces';
import { TableOptionsKey } from '@base/utils/constants';

export default class CreateTableService {
  isTicketGame = false;

  constructor(
    private socket: ISocketClient,
    private tableSettingsRepository: ITableSettingsService,
    private playersOnlineRepository: IPlayersOnlineRepository,
  ) {}

  get settings() {
    return this.tableSettingsRepository.getCreateTableSettings();
  }

  handlerTicketGame() {
    if (!this.isTicketGame && !this.settings.ladder) {
      this.isTicketGame = true;
      this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.RATING_GAME, true);
    } else if (!this.isTicketGame && this.settings.ladder) {
      this.isTicketGame = true;
    } else {
      this.isTicketGame = false;
      this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.RATING_GAME, false);
    }
  }

  handlerEntryFee(value: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.COST, value);
  }

  handlerRatedGame() {
    this.tableSettingsRepository.changeCreateTableOptions(
      TableOptionsKey.RATING_GAME,
      !this.settings.ratingGame
    );
  }

  handlerLadderGame() {
    if (!this.settings.ladder && !this.settings.ratingGame) {
      this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.RATING_GAME, true);
    }
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.LADDER, !this.settings.ladder);
  }

  handlerInvitation() {
    this.tableSettingsRepository.changeCreateTableOptions(
      TableOptionsKey.INVITE_ONLY,
      !this.settings.inviteOnly
    );
  }

  handlerDoubleOption(value: boolean) {
    this.setSign(Codes.TableFlags.NOTAKEB, value)
    this.tableSettingsRepository.changeCreateTableOptions(
      TableOptionsKey.MIN_POINTS,
      this.settings.minPoints === 1 || this.settings.minPoints === -1 ? 0 : 1
    );
  }

  handlerMinPoints(value: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.MIN_POINTS, value);
  }

  handlerMaxPoints(value: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.MAX_POINTS, value);
  }

  handlerCrawford() {
    this.tableSettingsRepository.changeCreateTableOptions(
      TableOptionsKey.MIN_POINTS,
      (this.settings.minPoints === 1 || this.settings.minPoints === 0) ? -1 : 1
    );
  }

  handlerPickColor(color: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.GAME_COLOR, color);
  }


  handlerWatchers() {
    this.tableSettingsRepository.changeCreateTableOptions(
      TableOptionsKey.NO_WATCHERS,
      !this.settings.noWatchers
    );
  }

  handlerManual(value: boolean) {
    this.setSign(Codes.TableFlags.MANUAL, value);
  }

  handlerDiscard(value: boolean) {
    this.setSign(Codes.TableFlags.DISCARD, value);
  }

  handlerTwoGameMatch(value: boolean) {
    this.setSign(Codes.TableFlags.TWOGAMEMATCH, value);
  }

  handlerLooserDeals(value: boolean) {
    this.setSign(Codes.TableFlags.LOSDEAL, value);
  }

  handlerMatchPointsFee(value: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.MAX_POINTS, value);
    if (value <= 1) this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.MIN_POINTS, 1);
  }

  handlerTimePerMove(value: number) {
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.WITH_TIME_PER_MOVE, value !== 0);
    this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.TIME_PER_MOVE, value);
  }

  createTable() {
    const createTableOptions = this.tableSettingsRepository.getCreateTableSettings();
    if (!this.isTicketGame) {
      createTableOptions.cost = 0;
    }
    const tableId = this.playersOnlineRepository.me?.getTable()?.tid || -1;
    this.sendCreateTable(tableId, createTableOptions);
  }

  sendCreateTable(tid: number, options: CreateTableSettings): void {
    const data = [Codes.Types.CP_TABLE_SERVE]
      .concat(Utils.decToInt16(tid))
      .concat(Utils.boolToInt8(options.inviteOnly))
      .concat(Utils.decToInt16(options.timeGame))
      .concat(Utils.decToInt16(options.timeGameAdd))
      .concat(Utils.boolToInt8(options.ratingGame))
      .concat(Utils.decToInt16(options.cost))
      .concat(Utils.decToInt16(options.reserved))
      .concat(Utils.decToInt16(options.gameColor))
      .concat(Utils.boolToInt8(options.withTime))
      .concat(Utils.decToInt16(options.timePerMove))
      .concat(Utils.boolToInt8(options.withTimePerMove))
      .concat(Utils.decToInt16(options.maxPoints))
      .concat(Utils.decToInt16(options.minPoints))
      .concat(Utils.boolToInt8(options.ladder))
      .concat(Utils.boolToInt8(options.noWatchers))
      .concat(Utils.decToUint32le(options.signs));

    this.socket.sendPacket(data);
  }

    /**
     * Включает или выключает битовый флаг в options.signs
     * @param sign название флага, например Codes.TableFlags.LOSDEAL
     * @param enabled включить или выключить флаг
     */
    private setSign(sign: number, enabled: boolean) {
      const signs = this.settings.signs;
      const newSigns = enabled ? signs | sign : signs & ~sign;
      this.tableSettingsRepository.changeCreateTableOptions(TableOptionsKey.SIGNS, newSigns)
    }

    getSign(sign: number) {
      return Boolean(this.settings.signs & sign);
    }
}
